import secureLocalStorage from "react-secure-storage";
import { formatNumber } from "@telerik/kendo-intl";
import * as React from "react";
import { NumericTextBox } from "@progress/kendo-react-inputs";
export default class TaskPercentageOnTrack extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      temp:this.props.dataItem[this.props.field]
    };
  }
  componentDidMount = () => {
    if(this.props.dataItem.inEdit&&document.getElementById("taskOntrackid")){
        document.getElementById("taskOntrackid").focus();
    }
  };
  handleChange = (e) => {
    this.setState({ temp: e.value });
  };
  handleBlur = (e) => {
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: this.state.temp,
    });
    if (
      this.props.field &&
      this.props.field === this.props.dataItem.inEdit 
    ) {
      let updateData = {
        ...this.props.dataItem,
        [this.props.field]: this.state.temp,
      };
        this.props.updateDropdownValue(updateData);
    }
  };
  handleEditCell = () => {
    if(( this.props.dataItem.isClosed===false || this.props.dataItem.isClosed==="Open" ) && (!this.props.isTask)){

    this.props.onEditCell(this.props.dataItem, this.props.field);
    }
  };
  render() {
    const { dataItem, field } = this.props;
    const loginUserId=parseInt(secureLocalStorage.getItem("loginUserId"));
    const ownerId=dataItem.ownerId;
    const dataValue =
      dataItem[field] === null || dataItem[field] == undefined
        ? ""
        : dataItem[field];
    if (this.props.field && this.props.field === this.props.dataItem.inEdit) {
      return (
        <td>
          <NumericTextBox
            defaultValue={dataValue}
            onChange={(e) => this.handleChange(e)}
            onBlur={this.handleBlur}
            min={0}
            max={100}
            id="taskOntrackid"
            format="n0"
          />
        </td>
      );
    } else {
      if((loginUserId===ownerId)&&this.props.dataItem.isClosed===false){
        return (
          <td onClick={this.handleEditCell}>{dataValue}</td>
        )
      }else{
        return (
          this.props.dataItem.roleName == "View Only" || this.props.dataItem.roleName == "Standard User"||this.props.dataItem.isClosed == true ? (
                <td >{dataValue}</td>
              ):(
                <td onClick={this.handleEditCell}>{dataValue}</td>
              )
        );
      }
    }
  }
}
